var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { attrs: { name: "thanks-form", width: 0 } }, [
    _c(
      "div",
      {
        staticClass:
          "modal modal__400 modal__thankYouJoin show outside-click-exclude",
        attrs: { id: "login_modal" }
      },
      [
        _c(
          "section",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.hide,
                expression: "hide"
              }
            ]
          },
          [
            _c("a", { staticClass: "modal__close", on: { click: _vm.hide } }, [
              _c("i", { staticClass: "icon-close" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__head text__bold text__center" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("THANK.TITLE")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__body text__center" }, [
              _c("p", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("THANK.P_1")) +
                    "\n                    "
                ),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("THANK.P_2")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "margin-t__40" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("THANK.P_3")) +
                    "\n                    "
                ),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("THANK.P_4")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "margin-t__40" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("THANK.P_5")) +
                    "\n                    "
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "text__bold",
                    class: { disabled: _vm.message },
                    attrs: { href: "#" },
                    on: { click: _vm.resend }
                  },
                  [_vm._v(_vm._s(_vm.message || _vm.$t("LINK.RESEND")))]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal__footer text__center margin-t__40" },
              [
                _c(
                  "button",
                  { staticClass: "btn full__width", on: { click: _vm.hide } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("BUTTON.CLOSE")) +
                        "\n                "
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }